/* eslint-disable @typescript-eslint/no-unused-vars */
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { LogLevel } from './Logger';
import { getAppInsights } from '..';
const critical = LogLevel.critical;
export class ApplicationInsightsLogger {
    logLevel;
    applicationInsights;
    constructor(logLevel = critical) {
        this.logLevel = logLevel;
        this.applicationInsights = getAppInsights().getValue();
    }
    debug(log, ...rest) {
        if (this.logLevel >= LogLevel.debug) {
            this.applicationInsights.trackTrace({ message: log, severityLevel: SeverityLevel.Verbose }, ...rest);
        }
        return Promise.resolve();
    }
    information(log, ...rest) {
        if (this.logLevel >= LogLevel.information) {
            this.applicationInsights.trackTrace({ message: log, severityLevel: SeverityLevel.Information }, ...rest);
        }
        return Promise.resolve();
    }
    warning(log, ...rest) {
        if (this.logLevel >= LogLevel.warning) {
            this.applicationInsights.trackTrace({ message: log, severityLevel: SeverityLevel.Warning }, ...rest);
        }
        return Promise.resolve();
    }
    error(log, ...rest) {
        if (this.logLevel >= LogLevel.error) {
            const error = rest[0]['error'] ?? rest[0];
            if (error instanceof Error) {
                this.applicationInsights.trackException({
                    error: error,
                    exception: error,
                    severityLevel: SeverityLevel.Error,
                }, { route: rest[0]['cause'], ...rest });
            }
            else {
                this.applicationInsights.trackTrace({ message: log, severityLevel: SeverityLevel.Error }, ...rest);
            }
        }
        return Promise.resolve();
    }
    critical(log, ...rest) {
        if (this.logLevel >= LogLevel.critical) {
            const error = rest[0]['error'] ?? rest[0];
            if (error instanceof Error) {
                this.applicationInsights.trackException({
                    error: error,
                    exception: error,
                    severityLevel: SeverityLevel.Error,
                }, { route: rest[0]['cause'], ...rest });
            }
            else {
                this.applicationInsights.trackTrace({ message: log, severityLevel: SeverityLevel.Critical }, ...rest);
            }
        }
        return Promise.resolve();
    }
}
